import { REGISTRATION_FIELD_KEYS } from "./registration-field.keys";

export const REGISTRATION_FIELD_LABEL_KEYS: Record<string, string> = {
  [REGISTRATION_FIELD_KEYS.email]: 'COMMON.FIELDS.EMAIL',
  [REGISTRATION_FIELD_KEYS.firstName]: 'COMMON.FIELDS.FIRST-NAME',
  [REGISTRATION_FIELD_KEYS.lastName]: 'COMMON.FIELDS.LAST-NAME',
  [REGISTRATION_FIELD_KEYS.companyName]: 'COMMON.FIELDS.COMPANY',
  [REGISTRATION_FIELD_KEYS.phoneMobile]: 'COMMON.FIELDS.PHONE-MOBILE',
  [REGISTRATION_FIELD_KEYS.iddNumber]: 'COMMON.FIELDS.IDD-NUMBER',
  [REGISTRATION_FIELD_KEYS.agentNumber]: 'COMMON.FIELDS.AGENT-NUMBER'
};

export const REGISTRATION_FIELD_REQUIRED_MESSAGE_KEYS: Record<string, string> = {
  [REGISTRATION_FIELD_KEYS.email]: 'VALIDATIONS.EMAIL-REQUIRED',
  [REGISTRATION_FIELD_KEYS.firstName]: 'VALIDATIONS.FIRST-NAME-REQUIRED',
  [REGISTRATION_FIELD_KEYS.lastName]: 'VALIDATIONS.LAST-NAME-REQUIRED',
  [REGISTRATION_FIELD_KEYS.companyName]: 'VALIDATIONS.COMPANY-REQUIRED',
  [REGISTRATION_FIELD_KEYS.phoneMobile]: 'VALIDATIONS.PHONE-MOBILE-REQUIRED',
  [REGISTRATION_FIELD_KEYS.iddNumber]: 'VALIDATIONS.IDD-NUMBER-REQUIRED',
  [REGISTRATION_FIELD_KEYS.agentNumber]: 'VALIDATIONS.AGENT-NUMBER-REQUIRED'
};